<!-- <template>
  <div v-if="$route.meta.footer" class="footer-menu footer-5-icons footer-menu-center-icon">
        <router-link :to="{ path: 'perks' }" class="footer_menu"> <i class="fa fa-perks"></i><span>Perks</span></router-link>
        <router-link :to="{ path: 'get-to-know-us' }" class="footer_menu"> <i class="fa fa-book-new"></i><span>Know Us</span></router-link>
        <router-link :to="{ path: 'home' }" class="footer_menu"><i class="fa fa-home"></i><span>Home</span></router-link>
        <router-link :to="{ path: 'explore-the-world' }" class="footer_menu"> <i class="fa fa-globe-africa"></i><span>Explore</span></router-link>
        <router-link :to="{ path: 'menu' }" class="footer_menu"> <i class="fa fa-bars"></i><span>Menu</span></router-link>
        <div class="clear"></div>
    </div> 
</template> -->


<template>
  <div v-if="$route.meta.footer" class="footer-menu footer-5-icons footer-menu-center-icon">
        <router-link :to="{ path: 'perks' }" class="footer_menu"> <i class="fa fa-perks c"></i><span>Income</span></router-link>
        <router-link :to="{ path: 'life-insurance-opportunity' }" class="footer_menu"> <i class="fa fa-book-new c"></i><span>LIO</span></router-link>
        <router-link :to="{ path: 'home' }" class="footer_menu"><i class="fa fa-home-new c"></i><span>Home</span></router-link>
        <!-- <router-link :to="{ path: 'home' }" class="footer_menu"><i class="fa fa-home"></i><span>Home</span></router-link> -->
        <router-link :to="{ path: 'explore-the-world' }" class="footer_menu"> <i class="fa fa-global-new c"></i><span>Explore</span></router-link>
        <router-link :to="{ path: 'menu' }" class="footer_menu"> <i class="fa fa-bars fa-2"></i><span>Menu</span></router-link>
        <div class="clear"></div>
    </div> 
</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fa-bars{
  font-size: 18px !important;
  padding-bottom: 5px;
  padding-top: 14px;
}
</style>
